import { Controller } from "@hotwired/stimulus"

// Reads data-ga4-event/data-ga4-type straight off the dataset rather than as Stimulus values:
// the attribute names are shared markup with track_order_controller.js, so they cannot take this
// controller's value prefix. Both are rendered conditionally and are absent as often as not.
export default class extends Controller {
  track() {
    const { ga4Event, ga4Type } = this.element.dataset;
    if (!ga4Event || !ga4Type) { return; }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: ga4Event, type: ga4Type });
  }
}
